<template>
  <div class="auth-error">
    <x-logo height="36" class="error-logo" />
    <x-heading size="5">There was an error logging you in.</x-heading>
    <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
    <a :href="getAfterLoginUrlInCaseOfCallbackError()">
      <x-onx-sso-button text="Try logging in again with onX" />
    </a>
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script setup>
import xLogo from '@/components/shared/x-logo'
import xHeading from '@/components/shared/x-heading'
import xOnxSsoButton from '@/components/x-onx-sso-button'
import { getAfterLoginUrlInCaseOfCallbackError } from '@/services/identity-client'
</script>

<style lang="scss" scoped>
.auth-error {
  text-align: center;
  width: 500px;
  margin: 50px auto 0px auto;
}
.error-logo {
  margin-bottom: 50px;
}
</style>
